import logoPodio from 'assets/img/elbb/logo_podio.png';
import React, { useEffect, useState } from 'react';
import { buscarIniciativasVencedorasElbb } from 'services/iniciativa.service';
import { IniciativaFormatada } from 'types/iniciativa';
import { IniciativaCardElbb } from './IniciativaCardElbb';
import './PodioElbb.scss';

export const PodioElbb: React.FC = () => {
  const [iniciativas, setIniciativas] = useState<IniciativaFormatada[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function carregarVencedores() {
      try {
        setLoading(true);
        const data = await buscarIniciativasVencedorasElbb();
        setIniciativas(
          data
            .filter((ini) => ini.categoryPremio === 'ELBB')
            .sort((a, b) => {
              const posA = a.position ?? Number.POSITIVE_INFINITY;
              const posB = b.position ?? Number.POSITIVE_INFINITY;
              if (posA !== posB) return posA - posB;
              return b.totalElogios - a.totalElogios;
            })
            .slice(0, 3)
        );
      } catch (error) {
        // Sem dados reais o pódio fica oculto; nunca exibir vencedoras simuladas.
        console.error('Erro ao carregar pódio ELBB:', error);
        setIniciativas([]);
      } finally {
        setLoading(false);
      }
    }

    carregarVencedores();
  }, []);

  if (!loading && iniciativas.length < 3) return null;

  // Mesma ordem visual do protótipo: 2º (esquerda), 1º (centro), 3º (direita).
  const posicoes = [
    { colocacao: 2, label: '2º LUGAR', iniciativa: iniciativas[1], styleClass: 'silver', pedestalClass: 'podio-elbb__step--2' },
    { colocacao: 1, label: '1º LUGAR', iniciativa: iniciativas[0], styleClass: 'gold', pedestalClass: 'podio-elbb__step--1' },
    { colocacao: 3, label: '3º LUGAR', iniciativa: iniciativas[2], styleClass: 'bronze', pedestalClass: 'podio-elbb__step--3' },
  ];

  return (
    <section className="iniciativas-section-elbb iniciativas-section-elbb--podio" aria-label="Pódio das iniciativas vencedoras ELBB">
      <h2 className="section-title-elbb" tabIndex={0}>
        Conheça as iniciativas vencedoras
      </h2>
      {loading ? (
        <div className="podio-elbb-loading">
          <div className="spinner" />
          <p>Carregando pódio das iniciativas ELBB...</p>
        </div>
      ) : (
        <div className="podio-elbb-container">
          <div className="podio-elbb-layout">
            {posicoes.map(({ colocacao, label, iniciativa, styleClass, pedestalClass }) => {
              if (!iniciativa) return null;

              return (
                <div
                  key={iniciativa.id}
                  className={`podio-elbb-coluna podio-elbb-coluna--${styleClass}`}
                >
                  <div className={`podio-elbb-card podio-elbb-card--${styleClass}`}>
                    <IniciativaCardElbb
                      {...iniciativa}
                      classificadaEtapa1
                      classificadaEtapa2={false}
                      classificadaIcon={
                        <img
                          src={logoPodio}
                          alt=""
                          aria-hidden="true"
                          className="podio-elbb-card__logo"
                        />
                      }
                      classificadaLabel={label}
                    />
                  </div>

                  <div className={`podio-elbb__step ${pedestalClass}`}>
                    <div className="podio-elbb__step-number">{colocacao}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
};
